import { useAppSelector } from '../shared/hooks/use-app-selector';

import {
  hasInitializationError,
  getInitializationErrorName,
  getInitializationErrorMessage,
} from '../selectors';

export function useInitializeError() {
  const hasError = useAppSelector(hasInitializationError);
  const errorName = useAppSelector(getInitializationErrorName);
  const errorMessage = useAppSelector(getInitializationErrorMessage);

  return {
    hasInitializationError: hasError,
    initializationErrorName: errorName,
    initializationErrorMessage: errorMessage,
  };
}
